import React, { Fragment } from 'react'

export const textBuilder = (text, ...args) => {
  const textParts = text.split(/{\d{1,}}/)
  const placeholders = text.match(/{\d{1,}}/g);

  let index = 0;

  const components = [<Fragment key={index}>{textParts[0]}</Fragment>]

  for (let i = 1; i < textParts.length; i++) {
    index++
    const argIndex = placeholders[i - 1].replace("{", "").replace("}", "")

    if (argIndex > args.length - 1) {
      return (
        <Fragment>{`Text parameter with index ${argIndex} is missing.`}</Fragment>
      )
    }

    components.push(<Fragment key={index}>{args[argIndex]}</Fragment>)
    index++
    components.push(<Fragment key={index}>{textParts[i]}</Fragment>)
  }

  return (
    <Fragment>
      {components}
    </Fragment>
  )
}
